define('modules/common/controller/Router',[], function() {
	var Controller = function($scope, Token, $rootScope, $location, DatiCliente, Studio, $stateParams, LoadingHandler, VERSION, CredenzialiUtente, Analytics) {

		$scope.menuOpened = false;
		$scope.withMenu = false;
		$scope.aliasStudio = '';

		$rootScope.$on('$stateChangeStart',
			function(event, toState, toParams, fromState, fromParams) {

				//Dato che ora il Token è salvato nel session storage, questo controllo va fatto in ogni caso
				if (Studio.getAlias() === "") {
					Studio.setAlias(toParams.aliasStudio || "studio");
				}

				if (toState.requireToken && !Token.isset()) {
					LoadingHandler.reset();
					$location.path('/' + Studio.getAlias() + '/login');
				}

				if (toState.withMenu === false) {
					$scope.menuOpened = false;
				}

				$scope.withMenu = toState.withMenu;
				$scope.aliasStudio = Studio.getAlias();

			});

		$rootScope.$on('$stateChangeSuccess',
			function(event, toState, toParams, fromState, fromParams) {
				Analytics.track();
			});


		$scope.logout = function($event) {
			Token.reset();
			DatiCliente.reset();
			CredenzialiUtente.reset();
			$location.path('/' + Studio.getAlias() + '/login');
			$event.stopPropagation();
		};

		$scope.go = function(route) {
			$location.path('/' + Studio.getAlias() + '/' + route);
		};

		$scope.toggleMenu = function($event) {
			$scope.menuOpened = !$scope.menuOpened;
			$event.stopPropagation();
		};

		$scope.dismissMenu = function($event) {
			if ($scope.menuOpened) {
				$scope.menuOpened = false;
			}
		};

		$scope.VERSION = VERSION;

	};

	return ["$scope", "Token", "$rootScope", "$location", "DatiCliente", "Studio", "$stateParams", "LoadingHandler", "VERSION", "CredenzialiUtente", "Analytics", Controller];
});
